module.exports = __webpack_public_path__ + "img/banner-middle-2.23bbf22a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-middle/banner-middle-2.jpg
// module id = z2WY
// module chunks = 1